<template>
  <page-template >
    <template slot="page-content">
      <div class="taste--template bg-beige page-template">
        <!-- page bg -->
        <div class="db fixed top-0 bottom-0 bg-beige w-100 vh-100 z-bg"></div>
        <!-- <div v-if="page.background_color" class="db fixed top-0 bottom-0 w-100 vh-100 z-1001" :style="{opacity: (1.1 - bgOpaciy), 'background-color': page.background_color }"></div> -->
        <!-- <div v-else class="db fixed top-0 bottom-0 w-100 vh-100 bg-blue z-1001" :style="{opacity: (1.1 - bgOpaciy), 'background-color': page.background_color }"></div> -->
        <!-- page content -->
        <div class="relative z-content">
          <!-- <img class="dn db-ns absolute" :style="calcParallax('tasteBubble', 300, 500, 'right:-70px')" src="/uploads/tastebubble.svg" ref="tasteBubble" />
          <img class="dn db-ns absolute" :style="{'top':parallax + 'px', 'display': 'none'}" src="" /> -->
        </div>
        <!-- CONTENT -->
        <div class="relative z-content pb5">
          <div class="relative">
            <div class="relative mw8-5 center pt4 pt5-ns">

              <div class="row relative center mb4">          
                <div class="db relative w-100 taste-heading"><h1 class="f1 is-navy tl lh-heading f45px is-blenny mw7-ns">{{ page.title }}
                  <img class="dib mb3 lil-hat" src="/uploads/OL20-OL21_Icons/CocktailMagicIcon/CocktailMagicIconSVG/CocktailMagic_Icon_Infrared.svg" />
                  </h1>
                <h2 class="db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content">Deep in McLaren Pass, discover craft cocktails, magic shows and live music at Cocktail Magic! Three new bars will make their debut including Frank & Vlad's, The Silver Girls and The Buttery Tipple.</h2>
                </div>
              </div>
            </div>

            <section class="relative mt6 mt0-ns">
              <div class="relative container-fluid-sm mw8-5 center">
                <div class="row center">

                  <div class="relative col-xs-12 col-sm-4" v-for="(block, index) in page.content_blocks">
                    <div v-if="index === 1" class="dn db-ns top-0 left-0 h-100 absolute center cm-border is-navy"></div>
                    <div v-if="index === 1" class="dn db-ns top-0 right-0 h-100 absolute center cm-border is-navy"></div>
                    <div class="w-100 center ph0 ph3-ns">
                      <img class="mb3 center ml0 w-100 mw100" v-lazy="block.image" />
                      <h2 class="f2 tl is-tablet-bold is-black">{{ block.title }}</h2>
                        <div v-if="block.is_cocktails" class="mt3">
                          <div class="mv2" v-for="item in block.items">
                            <h3 class="f3 tl is-tablet-bold is-black">{{ item.title }}</h3>
                              <hr class="cocktail-divide">
                            <p v-if="item.description" class="f5 mt2 is-tablet-regular is-black">
                              <p><b>{{ item.description }}</b></p>
                              <p>{{ item.description2 }}</p>
                            </p>
                            <p v-if="item.description3" class=" f5 mt2 is-tablet-regular is-black">
                              <p><b>Specialty Cocktail Preview: </b></p>
                              <p><b>{{ item.description3 }}</b></p>
                              <p>{{ item.description4 }}</p>
                            </p>
                            <!-- <a class="db mt2 relative is-tablet-bold f15px" :href="item.link" target="_blank">More →</a> -->
                          </div>
                        </div>
                        <div v-if="block.is_magic" class="mt3">
                          <div class="mv2" v-for="item in block.items">
                            <h3 class="f3 tl is-tablet-bold is-black">{{ item.title }}</h3>
          
                            <p v-if="item.description" class="f5 mt2 is-tablet-regular is-black">
                              <h3>{{ item.description }}</h3>
                              
                            </p>
                            <a class="db mt2 relative is-tablet-bold f15px" :href="item.link" target="_blank">More →</a>
                          </div>
                        </div>
                    </div>
                  </div>


                      <!--
                      <div class="col-xs-12 col-sm-6 pb4" v-for="vendor in page.wineries_section.wineries_list">
                        <a class="flex relative flex-row items-center is-tablet-bold f15px" :href="vendor.link" :title="vendor.title" target="_blank">
                          <h3 class="is-tablet-bold is-black f20px">{{vendor.title}}</h3>
                          <simple-svg class="checkout r45" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg>
                        </a>
                      </div>
                      -->
                </div>
              </div>
            </section>

            <!--
            <section class="relative mw8-5 center">
              <div class="row">
                <div class="" v-for="item in page.wineries_section.wineries_list">
                  {{ item.title }}
                </div>
              </div>
            </section>
            -->
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
export default {
  components: {
    PageTemplate,
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      parallax:null,
      window: {
        width: 0,
        height: 0
      },
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('cocktail-magic.markdown');
      return pageData[0];
    }
  },
  methods : {
    scrollBg: function() {
      console.log('scrollBg', window.scrollY, this.bgOpaciy);
        if ((document.body.getBoundingClientRect()).top > this.scrollPos) {
          console.log('document, this.bgOpacity: ', this.bgOpaciy);
          //this.bgOpaciy = 0 + (1 - window.scrollY * 0.001);
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = (window.scrollY * 0.001);
            console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          }
          else {
            this.bgOpacity = 0;
            console.log('else', window.scrollY, this.bgOpacity);
          }
        }
        else {
          //this.bgOpaciy = this.bgOpaciy - (window.scrollY * (0.0001));
          this.bgOpaciy = (window.scrollY * 0.001);
          console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = (document.body.getBoundingClientRect()).top;
    },
    calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },
    scrollParallax: function(){
      // console.log(window.scrollY);
      this.parallax = window.scrollY;
    },
  },
  created() {
    window.addEventListener('resize', this.scrollBg);
    window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.scrollBg);
  },
  beforeMount() {
    //
  },
  mounted() {

    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener('resize', this.scrollBg);
    window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.scrollBg);
  }
}
</script>
